import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ubs-item-field',
  templateUrl: './item-field.component.html',
  styleUrls: ['./item-field.component.scss']
})
export class ItemFieldComponent implements OnInit, OnChanges {
  @Input() field:any;
  title:string;
  value:any;
  isImage:boolean = false;
  imageUrl:string;
  
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["field"]){
      console.log(this.field)
      this.title = this.field.column.title;
      this.value = this.field.value;
      if(this.value != undefined && this.value != null){
        if(this.value.includes(".png")){
          this.isImage = true;
          this.imageUrl = "https://kwikstore-dev:8443"+this.value
        }
      }
    }
  }

}
